import { render, staticRenderFns } from "./myCoupon.vue?vue&type=template&id=72b0a242&scoped=true&"
import script from "./myCoupon.vue?vue&type=script&lang=js&"
export * from "./myCoupon.vue?vue&type=script&lang=js&"
import style0 from "./myCoupon.vue?vue&type=style&index=0&id=72b0a242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0a242",
  null
  
)

export default component.exports